import { Icon } from '../Icon';
import logoDark from '../../assets/images/electroz_english_dark.svg';
import { useSiteContent } from '../../hooks/useSiteContent';

export function Footer() {
  const year = new Date().getFullYear();
  const { data } = useSiteContent();
  const contact = data?.contactInfo;

  return (
    <footer className="bg-navy-900 text-navy-300">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-3">
              <img src={logoDark} alt="Electroz" className="h-14 w-auto" />
            </div>
            <p className="max-w-xs text-sm leading-relaxed text-navy-400">
              Professional electrical contracting services for homes and businesses. Licensed, insured, and trusted.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="mb-3 text-[13px] font-semibold uppercase tracking-wider text-navy-400">Services</h4>
            <ul className="space-y-2 text-sm">
              {['New Wiring', 'Switchboard Upgrades', 'Lighting Installation', 'CCTV Installation', 'Maintenance & Repair', 'Industrial Wiring'].map((s) => (
                <li key={s}>
                  <a href="/#services" className="hover:text-white transition-colors">{s}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          {contact && (
            <div>
              <h4 className="mb-3 text-[13px] font-semibold uppercase tracking-wider text-navy-400">Contact</h4>
              <ul className="space-y-3 text-sm">
                {contact.phone && (
                  <li>
                    <a href={`tel:${contact.phone}`} className="flex items-center gap-2 hover:text-white transition-colors">
                      <Icon name="phone" size={15} />
                      <span>{contact.phone}</span>
                    </a>
                  </li>
                )}
                {contact.email && (
                  <li>
                    <a href={`mailto:${contact.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
                      <Icon name="mail" size={15} />
                      <span>{contact.email}</span>
                    </a>
                  </li>
                )}
                {contact.address && (
                  <li className="flex items-start gap-2">
                    <Icon name="mapPin" size={15} className="mt-0.5 shrink-0" />
                    <span>{contact.address}</span>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>

        <div className="mt-10 border-t border-navy-800 pt-6 text-center text-[13px] text-navy-500">
          &copy; {year} Electroz. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
